var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"toggleDesc",staticClass:"toggle-desc",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDesc.apply(null, arguments)}}},[(_vm.isShowDefault)?[_c('span',{staticClass:"toggle-desc-text"},[_vm._v(_vm._s(_vm.text))]),_c('i',{key:"arrows",class:_vm.classname})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }